import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {isMobile, isIos} from '../../static/helper';

const vw1920 = (px) => {
  return (px / 1920) * 100 + "vw";
}
const vw = (px) => {
  return (px / (isMobile() || isIos() ? 640 : 1920)) * 100 + "vw";
}
const Wrapper = styled.div`
    display: ${props => props.display};
    width: ${vw(52)}; /* Set the size of the progress bar */
    height: ${vw(52)};
    position: absolute; /* Enable clipping */
    clip: ${props => props.progress && props.progress.progress < 50 ? `rect(0, ${vw(52)}, ${vw(52)}, ${vw(26)})` : `rect(auto, auto, auto, auto)`}; /* Hide half of the progress bar */
`
const LeftSide = styled.div`
    width: ${vw(42)};
    height: ${vw(42)};
    border: ${vw(5)} solid #f889a0;
    border-radius: ${vw(50)};
    position: absolute;
    clip: rect(0px, ${vw(26)}, ${vw(52)}, 0px);
    transform: ${props => props.progress && props.progress.progress ? `rotate(${(360 * props.progress.progress) / 100}deg)` : `rotate(0deg)`};
`
const RightSide = styled.div`
    width: ${vw(42)};
    height: ${vw(42)};
    border: ${vw(5)} solid #f889a0;
    border-radius: ${vw(50)};
    position: absolute;
    clip: rect(0px, ${vw(26)}, ${vw(52)}, 0px);
    transform: ${props => props.progress && props.progress.progress && props.progress.progress < 50 ? `rotate(${(180 * (props.progress.progress * 2)) / 100}deg)` : props.progress && props.progress.progress >= 50 ? `rotate(180deg)` : `rotate(0deg)`};
`


function CircleProgressBar(props) {

  const [display, setDisplay] = useState("none")

  useEffect(()=>{
    if(props.progress){
      setTimeout(() => {
        setDisplay("block");
      }, 300);
    }
  }, [])

  return (
    <Wrapper className="play" {...props} display={display}>
      <RightSide className="play" {...props}  />
      <LeftSide className="play" {...props} />
    </Wrapper>
  );
}

export default CircleProgressBar;
